window.$ = window.jQuery = global.jQuery = require('jquery');
import '../../modules/system/assets/js/framework';
import '../../modules/system/assets/js/framework.extras';
import 'popper.js';
import 'bootstrap';
import 'lazysizes';
import 'select2';
import 'select2/dist/js/i18n/ru';

$(() => { // Shorthand for $( document ).ready()
  "use strict";

  require('bootstrap-colorpicker/dist/js/bootstrap-colorpicker');

  $('[data-toggle="tooltip"]').tooltip();

  window.onload = function() {
    //iconify.design icons
    let iconifyScript = document.createElement('script');
    iconifyScript.type = 'text/javascript';
    iconifyScript.src = 'https://code.iconify.design/1/1.0.6/iconify.min.js';
    iconifyScript.setAttribute('charset', 'utf-8');
    document.getElementsByTagName('body')[0].appendChild(iconifyScript);
  }

  $(function () {

    // инициализация wysiwyg редактора tinymce
    tinymce.init({
      selector: '.wysiwyg',
      menubar: false,
      branding: false,
    })
    // инициализация bootstrap tooltip
    $('[data-toggle="tooltip"]').tooltip()

    // bootsrtap nav tabs
    $('[data-toggle="tab"]').on('click', function (e) {
      e.preventDefault()
      window.location.hash = $(this).attr('href');
      $(this).tab('show')
    })

    // активация вкладки nav tab (bootstrap) через url#hash
    // прокрутка до якоря, если хэш с разделителем "|" (#tab-name|message-id)
    toggleBootstrapTabByUrlHash()

    $(window).on('hashchange', function() {
      toggleBootstrapTabByUrlHash()
    });

    function toggleBootstrapTabByUrlHash() {
      let locationHash = window.location.hash
      if (!locationHash) {
        return false
      }

      let tabHref = locationHash
      let anchor = ''
      locationHash = locationHash.replace(/%7C/g, "|")
      window.location.hash = locationHash
      let complexHash = locationHash.split('|')
      if (complexHash.length <= 2) {
        tabHref = complexHash[0]
        anchor = complexHash[1]
      }

      let tabLink = $(document).find('[href="' +tabHref +'"]')
      if (!tabLink) {
        return false
      }

      //show tab from url #hash
      tabLink.tab('show')

      //scroll to anchor if hash is complex - #tabID|anchorID
      if (anchor) {
        let selectorToScroll = $(document).find('#'+anchor)

        if (!selectorToScroll) return false;

        setTimeout(function () {
          selectorToScroll.attr('tabindex', 0).focus()
          $('html, body').animate({
            'scrollTop':   selectorToScroll.offset().top
          }, 300);
        }, 300)
      }
    }

    initSlugable()

    function initSlugable() {
      let sluggable = $(document).find('._sluggable')
      let slugFromField = sluggable.data('slug-from')
      let slugFromFields = $(document).find('[name="'+ slugFromField +'"]')
      slugFromFields.each(function () {
        $(this).on('change', function () {
          sluggable.val(generateSlug($(this).val()))
        })
      })
    }

    // Slug generate from string (only for english text)
    function generateSlug(text) {
      return text.trim().toLowerCase()
          .replace(/ +/g, '-');
    }
  });

  $(document).on('click', 'td', function () {
    if ($(this).hasClass('_js_no_link')) return

    let parentTr = $(this).parents('tr')
    let updateURL = parentTr.data('update-url');
    goToPage(updateURL)
  })

  function goToPage(updateURL) {
    window.location.href=updateURL
    return false
  }

  let form = $('._js_form_crud')
  form.on('change', function () {
    let deleteBtn = $(document).find('._js_delete_btn')
    let checkboxes = $(document).find('._js_delete_item')
    let checkedQty = 0

    checkboxes.each(function () {
      if ($(this).prop('checked')) {
        checkedQty++
      }
    })

    if (checkedQty > 0) {
      deleteBtn.removeAttr('disabled')
    } else {
      deleteBtn.attr('disabled', 'disabled')
    }
  })
});
